import {ReactElement, ReactNode} from "react";
import {useAppSelector} from "../../lib/redux/hooks";
import {i18nSelectors} from "./i18nSlice";
import {IntlProvider} from "react-intl";
import {getTranslations} from "./translations";

export interface TranslationProviderProps {
    children: ReactNode
}

export function TranslationProvider(props: TranslationProviderProps): ReactElement {
    const language = useAppSelector(i18nSelectors.language);
    return <IntlProvider locale={`${language}-CH`} messages={getTranslations(language)}>
        {props.children}
    </IntlProvider>
}